import { Component, inject, OnInit } from '@angular/core';
import { IntegrationAppsService } from '../../integration-apps.service';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { GetIntegrationAppListResponse, SlimIntegrationApp } from '@proto/odoo/integrations';
import { ToastService } from 'src/app/toast.service';
import { I18NextService } from 'angular-i18next';

@Component({
  selector: 'app-integration-apps-marketplace',
  templateUrl: './integration-apps-marketplace.component.html',
  standalone: false
})
export class IntegrationAppsMarketplaceComponent implements OnInit {

  private integrationService = inject(IntegrationAppsService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private toastService = inject(ToastService);
  private i18Next = inject(I18NextService);

  public preselectedSubId: string;
  public preselectedSubName: string;
  public idsOfInstalledApps: string[];

  public integrationAppListResponse: GetIntegrationAppListResponse;
  public marketplaceAppsInitial: SlimIntegrationApp[] = [];
  public marketplaceAppsToDisplay: SlimIntegrationApp[] = [];

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.preselectedSubId = params['subId'];
      this.preselectedSubName = params['subName'];
      this.idsOfInstalledApps = params['installed'];
    });
    this.fetchMarketplaceApps();
  }

  async fetchMarketplaceApps() {
    try {
      this.integrationAppListResponse = await firstValueFrom(this.integrationService.getMarketplaceApps());
    } catch (error) {
      this.toastService.error(this.i18Next.t('integration_apps_load_resources_error'), 'error');
      return;
    }

    if (this.integrationAppListResponse.apps) {
      this.marketplaceAppsInitial = this.integrationAppListResponse.apps;
      this.marketplaceAppsToDisplay = this.integrationAppListResponse.apps;
    } else {
      this.toastService.error(this.i18Next.t('integration_apps_app_list_error'), 'error');
      return;
    }
  }

  isAlreadyInstalled(appUuid: string): boolean {
    if (this.idsOfInstalledApps) {
      return this.idsOfInstalledApps.includes(appUuid);
    } else {
      return false;
    }
  }

  filter(event: any) {
    this.marketplaceAppsToDisplay = this.marketplaceAppsInitial.filter(app => app.name.toLowerCase().includes(event.toLowerCase()) || app.vendor.toLowerCase().includes(event.toLowerCase()));
  }

  onBack() {
    this.router.navigate(['/integration-apps/hub']);
  }

}
